// const api = 'http://localhost:5002'
const api = 'https://api.inchbyinch.eu'
module.exports = {api}